import { useState } from "react";
import styles from "./ProposalManagement.module.css";

import Evaluation from "./Evaluation/Evaluation";
import Consultation from "./Consultation/Consultation";


export default function ProposalManagement({ }) {
    const [activeTab, setActiveTab] = useState("evaluation");

    return (
        <div className={styles.proposalManagement}>
            <div className={styles.tabContainer}>
                <div className={styles.tabSelectors}>
                    <div 
                        className={`${styles.tab} ${activeTab === "evaluation" ? styles.active : ""}`}
                        onClick={() => setActiveTab("evaluation")}
                    >
                        모의 견적 산출
                    </div>
                    <div 
                        className={`${styles.tab} ${activeTab === "consultation" ? styles.active : ""}`}
                        onClick={() => setActiveTab("consultation")}
                    >
                       출판 상담 신청
                    </div>
                </div>
            </div>

            <div className={styles.contentArea}>
                {activeTab === "evaluation" ? (
                    <Evaluation />
                ) : (
                    <Consultation />
                )}
            </div>
        </div>
    );
}